module.exports = __webpack_public_path__ + "static/media/cq_grassetto.74af4153.svg";